export const GoogleConsentMode = {
  sync(state) {
    const flags = {
      ad_storage: state.marketing ? 'granted' : 'denied',
      ad_user_data: state.marketing ? 'granted' : 'denied',
      ad_personalization: state.marketing ? 'granted' : 'denied',
      analytics_storage: state.measurement ? 'granted' : 'denied',
      personalization_storage: state.personalization ? 'granted' : 'denied',
      functionality_storage: 'granted',
      security_storage: 'granted',
    };
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', flags);
    } else {
      (window.dataLayer = window.dataLayer || []).push(['consent', 'update', flags]);
    }
  },
};
